import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Circle, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CaddyCartIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="#001A19"
    testID="caddy-cart-icon"
    title={t`Caddy Cart`}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M4.59 8.18h1.436v.717h5.743L15 9.615v3.59H1.718l.359-5.026H4.59Zm0 0V5.307m0 0v-3.95L1 3.873l3.59 1.436Z"
        fill="none"
      />
      <Circle
        cx={4.59}
        cy={13.205}
        r={1.436}
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <Circle
        cx={11.769}
        cy={13.205}
        r={1.436}
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M8.18 8.897v-3.23M8.538 6.744l2.513.717v1.077"
        fill="none"
      />
      <Circle cx={8.538} cy={2.795} r={1.795} fill="currentColor" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
